import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { StatBox } from '../../../components/shared';
import type { KvsResultStudentDetail } from '../../../services/kvsResultApi';

interface OutletCtx {
  student: KvsResultStudentDetail;
  fullName: string;
  attendancePct: number;
  level: string;
}

const levelColor = (lvl: string) => {
  if (lvl === 'Excellent') return 'text-emerald-600';
  if (lvl === 'Good') return 'text-blue-600';
  if (lvl === 'Average') return 'text-amber-600';
  return 'text-red-600';
};

const OverviewTab: React.FC = () => {
  const { student, fullName, attendancePct, level } = useOutletContext<OutletCtx>();

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatBox label="Marks" value={`${student.marks}%`} color={student.marks >= 75 ? 'text-emerald-600' : student.marks >= 60 ? 'text-amber-600' : 'text-red-600'} />
        <StatBox label="Attendance" value={`${attendancePct}%`} color={attendancePct >= 75 ? 'text-emerald-600' : 'text-amber-600'} />
        <StatBox label="Level" value={level} color={levelColor(level)} />
        <StatBox label="Class & Section" value={`Class ${student.class} – ${student.section}`} color="text-gray-700" />
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-700 mb-4">Student Details</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm text-gray-700">
          <div><span className="text-gray-500">Name:</span> <span className="font-medium">{fullName}</span></div>
          <div><span className="text-gray-500">Student ID:</span> <span className="font-medium">{student.studentID}</span></div>
          <div><span className="text-gray-500">Roll No:</span> <span className="font-medium">{student.rollNo || '—'}</span></div>
          <div><span className="text-gray-500">School:</span> <span className="font-medium">{student.schoolName}</span></div>
          <div><span className="text-gray-500">Academic Session:</span> <span className="font-medium">{student.academicSession}</span></div>
          <div><span className="text-gray-500">Term:</span> <span className="font-medium">{student.term}</span></div>
          <div><span className="text-gray-500">Days Present:</span> <span className="font-medium">{student.presentDay} / {student.workingDay}</span></div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
